import { Component, OnInit, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { AreaData } from '../model/area.model';
import { ApiService } from '../services/api.service';
import { AreaFilterService } from '../services/area-filter.service';

@Component({
  selector: 'app-areadetails',
  templateUrl: './areadetails.component.html',
  styleUrls: ['./areadetails.component.scss']
})
export class AreadetailsComponent implements OnInit {
  displayedColumns: string[] = ['areaCode', 'areaName', 'actions'];
  dataSource = new MatTableDataSource<AreaData>(null);
  area: AreaData = {
    areaCode: 0,
    areaName: ''
  }
  areas:AreaData [];
  enableButton = false;
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;
  constructor(private apiService: ApiService,private _snackBar: MatSnackBar, private areaFilterService: AreaFilterService) { 
    
  }
  ngOnInit(): void {
    this.getAreaData();
  }

  getAreaData() {
    this.apiService.getAreaDetails()
      .subscribe(data => {
        // Filter areas by logged-in user's area names
        const filteredAreas = this.areaFilterService.filterAreasByAreaName(data.areas);
        this.areas = filteredAreas;
        this.dataSource = new MatTableDataSource<AreaData>(filteredAreas);
        this.dataSource.sort = this.sort;
        this.dataSource.paginator = this.paginator;
      });
  }

  validateAreaName(areaName: string){
    const valueExsist = this.areas.filter(function (item) {
        return item.areaName === areaName.trim();
    });
    if(valueExsist.length == 0 && areaName.trim() != ''){
      this.enableButton = true;
    } else{
      this.enableButton = false;
    }
  }
  applyFilter(filterValue: string) {
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  addArea(area: AreaData) {    
      this.apiService.addNewArea(area).subscribe(data => {
        this.getAreaData();
        this.area.areaName = '';
        this.enableButton = false;
        this._snackBar.open('New area added', 'Close', {
          duration: 3000
        });
      });
      }

  deleteArea(area: AreaData) {
    this.apiService.deleteArea(area)
    .subscribe(data => {
      this.getAreaData();
      this._snackBar.open('Area deleted', 'Close', {
        duration: 3000
      });
    });
  }


}
